import _ from 'lodash';
import { log } from '@swiper/core';
import config from '~/config';
import path from 'path';
import fs from 'fs-extra';
import { generateId } from '../utils';
import * as Errors from './Errors';

export class Service {

  constructor( opts={} ) {
    _.assign( this, opts );
    if ( ! this.name ) {
      Service.throw( `Cannot create service without name` );
    }
    if ( ! this.dir ) this.dir = config.dir( this.name );
  }

  get extension() { return '.json'; }

  async setup( a, p ) {
    this.app = a;
    this.path = p;
    if ( this.dir ) await fs.ensureDir( this.dir );
  }

  generateId( ...args ) {
    return generateId( this.idprefix || this.name, ...args );
  }

  pathto( ...args ) {
    const fixExt = _.isBoolean( _.last( args ) ) ? args.pop() : true;
    const file = path.resolve( this.dir, ...args );
    if ( fixExt ) {
      if ( ! file.endsWith( this.extension ) ) return file + this.extension;
    }
    return file;
  }

  static error( type, message, ...args ) {
    const Err = Service.Errors[ type ] || Service.Errors.GeneralError;
    return new Err( message, ...args );
  }
  static throw( type, message, ...args ) {
    throw this.error( type, message, ...args );
  }
  error( ...args ) { return Service.error( ...args ); }
  throw( ...args ) { return Service.throw( ...args ); }

  // eslint-disable-next-line no-process-env
  isProd() { return process.env.NODE_ENV === 'production'; }
  isNotProd() { return ! this.isProd(); }
}

Service.Errors = Errors;
